import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '@material';
import { SimpleBannerComponent } from './simple-banner.component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [SimpleBannerComponent],
  exports: [SimpleBannerComponent],
})
export class SimpleBannerModule {}
